// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"441205b9","946":"20bfac9c"}[chunkId] + ".chunk.js";
};